import { createResource } from 'react-resource-router/resources';

import { ResourceContext } from '@townsquare/router';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import { PAGINATION_SIZE } from './constants';
import { fetchPopularFeed } from './hooks/fetch-popular-feed';
import { getTimeframe, type PopularFeedResponse, type Timeframe } from './types';

export const popularFeedResource = createResource<PopularFeedResponse | undefined>({
  getData: async (routerContext, resourceContext) => {
    const { workspace } = resourceContext as ResourceContext;

    if (!workspace || !workspace.cloudId || !isGateEnabled('townsquare_enable_popular_feed')) {
      return undefined;
    }

    const timeframe: Timeframe = getTimeframe(routerContext.query.timeGranularity);

    // Load longer first page of results
    return fetchPopularFeed(workspace.cloudId, timeframe, PAGINATION_SIZE * 2).catch(() => {
      console.error('Error occurred while fetching popular feed');

      return undefined;
    });
  },
  getKey: routerContext => {
    const timeframe = getTimeframe(routerContext.query.timeGranularity);

    return `popular-feed-posts-key-${timeframe}`;
  },
  type: 'POPULAR_FEED_POSTS',
  maxAge: 60_000 * 30, // Cache for 30 minutes
});
